import React, {useEffect, useState} from "react";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import LoadingInside from "../../components/Loading/LoadingInside";
import s from "./Locations.module.scss";
import SeoMeta from "../../components/SeoMeta";

const apiUrl = process.env.REACT_APP_API_URL;

const Locations = () => {
    const navigate = useNavigate();
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {

        axios.get(`${apiUrl}/api/locations`)
            .then(res => {

                setLocations(
                    res.data.data || res.data
                );

            })
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                setLoading(false);
            });

    }, []);

    if (loading) {
        return (
            <LoadingInside height="50vh"/>
        );
    }
    return (
        <>

            <SeoMeta
                slug="/locations"
                fallback={{
                    title: "Explore Locations",
                    description:
                        "Explore sightseeing locations and tours"
                }}
            />
            <div className={s.page}>

                <div className={s.header}>
                    <h1>
                        Explore Locations
                    </h1>

                    <p>
                        Find your perfect destination
                    </p>
                </div>
                <div className={s.grid}>

                    {
                        locations.map(location => (

                            <div
                                key={location.id}
                                className={s.card}
                                onClick={() => {
                                    navigate(
                                        `/tours/location/${location.slug}`
                                    );
                                }}
                            >

                                <div className={s.imageWrapper}>

                                    <img
                                        src={
                                            location.image ||
                                            "/images/location-placeholder.jpg"
                                        }
                                        alt={
                                            location.name
                                        }
                                    />

                                </div>
                                <div className={s.content}>

                                    <h3>
                                        {location.name}
                                    </h3>

                                    {
                                        location.description &&
                                        <p>
                                            {
                                                location.description
                                            }
                                        </p>
                                    }

                                </div>
                            </div>

                        ))
                    }

                </div>
            </div>

        </>
    );
};

export default Locations;